// frontend/src/app/guards/admin.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AdminAuthService } from '../services/admin-auth.service';

/** Section admin : session admin requise (identifiants propriétaire), sinon page de connexion admin. */
export const adminGuard: CanActivateFn = () =>
  inject(AdminAuthService).isAuthenticated()
    ? true
    : inject(Router).createUrlTree(['/admin/login']);
